import React from 'react';
import { MustIncludeOneOfTestIdProps } from '../common/internal/test-id.types';
import { BarSection, ProgressBar } from './HBSegmentedBar.styles';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

export interface HBSegmentedBarProps {
    /** Array of segments to render; each segment's width is proportional to its amount relative to totalAmount. */
    categories: BarCategory[];
    /** Base value used to calculate segment widths as percentages; defaults to 100 when omitted. */
    totalAmount?: number;
    /** Height of the bar in pixels. Defaults to 10. */
    height?: number;
}

interface BarCategory {
    label: string;
    amount: number;
    color: string;
}

const HBSegmentedBar = ({
    categories,
    totalAmount,
    height = 10
}: HBSegmentedBarProps & MustIncludeOneOfTestIdProps) => {
    const total = totalAmount || 100;

    return (
        <ProgressBar height={height}>
            {categories.map(category => {
                const { amount, label, color } = category;

                return (
                    amount > 0 && (
                        <React.Fragment key={label}>
                            <BarSection
                                color={color}
                                percent={(amount * 100) / total || 0}
                            />
                            <VisuallyHidden.Root>{label}</VisuallyHidden.Root>
                        </React.Fragment>
                    )
                );
            })}
        </ProgressBar>
    );
};

export default HBSegmentedBar;
